import { render } from "./NuevoPedido.vue?vue&type=template&id=5a294915&scoped=true"
import script from "./NuevoPedido.vue?vue&type=script&lang=js"
export * from "./NuevoPedido.vue?vue&type=script&lang=js"

import "./NuevoPedido.vue?vue&type=style&index=0&id=5a294915&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a294915"]])

export default __exports__